import type { MakeOptionalExcept } from '@repo/types/utils';

import { infer as Infer, z } from 'zod';

import { userCreateSchema } from './userCreate.schema';

export const userEditSchema = userCreateSchema
  .extend({
    id: z.number(),
    active: z.boolean().optional(),
    force_password_change: z.boolean().optional(),
  })
  .omit({
    password: true,
  });

export const userEditSchemaParser = userEditSchema.transform((user) => {
  return {
    ...user,
    birthdate: user.birthdate || null,
    phone: user.phone || null,
  };
});

export type UserEditSchema = Infer<typeof userEditSchema>;
export type UserEditSchemaEditPayload = MakeOptionalExcept<UserEditSchema, 'id'>;
